import { toast } from "sonner";
import { DownloadSimple } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const download = async (f) => {
  try {
    const res = await api.get(`/files/${f.file_id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = f.filename || "file"; a.click();
    URL.revokeObjectURL(url);
  } catch (_e) { toast.error("Download failed"); }
};

export default function MessageFiles({ m }) {
  const files = m.attachments || [];
  if (!files.length) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-2" data-testid={`msg-attachments-${m.message_id}`}>
      {files.map(f => (
        <button key={f.file_id} type="button" onClick={() => download(f)} title={f.filename}
          data-testid={`msg-attachment-${f.file_id}`} className="btn-ghost text-[11px] h-7">
          <DownloadSimple size={11} weight="bold" />
          <span className="truncate max-w-[200px]">{f.filename}</span>
        </button>
      ))}
    </div>
  );
}
